(() => {
  const COMPONENT_SELECTOR = 'collection-ajax-experience';
  const ORIGINAL_LINK_SELECTOR = '[data-original-collection-link]';
  const ALLOWED_TEMPLATES = new Set(['collection-page-1', 'collection-page-2', 'collection-page-3']);

  const collectionHandleFromHref = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const collectionsIndex = parts.indexOf('collections');
      return collectionsIndex >= 0 ? parts[collectionsIndex + 1] || '' : '';
    } catch (error) {
      return '';
    }
  };

  const isSupportedComponent = (component) => {
    return component && ALLOWED_TEMPLATES.has(component.dataset.cardologyCollectionTemplate || '');
  };

  const rememberOriginalCollection = (component) => {
    if (!isSupportedComponent(component)) return false;

    const originalLink = component.querySelector(ORIGINAL_LINK_SELECTOR);
    if (!originalLink) return false;

    if (!component.dataset.originalCollectionUrl) {
      component.dataset.originalCollectionUrl = originalLink.href;
    }

    if (!component.dataset.originalCollectionTitle) {
      component.dataset.originalCollectionTitle = originalLink.textContent.trim();
    }

    if (!component.dataset.originalCollectionHandle) {
      component.dataset.originalCollectionHandle = collectionHandleFromHref(component.dataset.originalCollectionUrl);
    }

    return true;
  };

  const syncOriginalCollectionChip = (component, activeHandle) => {
    if (!rememberOriginalCollection(component)) return;

    const originalLink = component.querySelector(ORIGINAL_LINK_SELECTOR);
    const originalUrl = component.dataset.originalCollectionUrl;
    const originalTitle = component.dataset.originalCollectionTitle;
    const originalHandle = component.dataset.originalCollectionHandle;
    const currentHandle = activeHandle || component.dataset.collectionHandle || originalHandle;

    originalLink.href = originalUrl;
    originalLink.textContent = originalTitle;
    originalLink.dataset.preserveFilters = 'true';
    originalLink.hidden = false;

    component.querySelectorAll('[data-collection-link]').forEach((link) => {
      const handle = collectionHandleFromHref(link.href);
      const isOriginalLink = link === originalLink;
      const duplicatesOriginal = !isOriginalLink && handle === originalHandle;
      const isActive = isOriginalLink ? currentHandle === originalHandle : !duplicatesOriginal && handle === currentHandle;

      link.hidden = duplicatesOriginal;
      link.classList.toggle('is-active', isActive);

      if (isActive) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const initialize = () => {
    document.querySelectorAll(COMPONENT_SELECTOR).forEach((component) => {
      if (!isSupportedComponent(component)) return;
      rememberOriginalCollection(component);
      syncOriginalCollectionChip(component);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('collection:updated', (event) => {
    document.querySelectorAll(COMPONENT_SELECTOR).forEach((component) => {
      if (!isSupportedComponent(component)) return;
      syncOriginalCollectionChip(component, event.detail?.collectionHandle);
    });
  });

  window.addEventListener('popstate', () => {
    window.requestAnimationFrame(initialize);
  });
})();
